<h5>{{incomeApplicant['Title']}} {{incomeApplicant['FirstName']}} {{incomeApplicant['MiddleName']}} {{incomeApplicant['Surname']}}</h5>
@if (employmentIncome.length > 0) {
  <div>
    <h6>Employment income</h6>
    <dl class="c-detail__list">
      @for (i of employmentIncome; track i) {
        <dt class="c-detail__list-title">{{i.Description}}</dt>
        <dd class="c-detail__list-description">{{i.Value}}</dd>
      }
    </dl>
  </div>
}
@if (selfEmploymentIncome.length > 0) {
  <div>
    <h6>Self-employment income</h6>
    <dl class="c-detail__list">
      @for (i of selfEmploymentIncome; track i) {
        <dt class="c-detail__list-title">{{i.Description}}</dt>
        <dd class="c-detail__list-description">{{i.Value}}</dd>
      }
    </dl>
  </div>
}
@if (otherIncome.length > 0) {
  <div>
    <h6>Other income</h6>
    <dl class="c-detail__list">
      @for (i of otherIncome; track i) {
        <dt class="c-detail__list-title">{{i.Description}}</dt>
        <dd class="c-detail__list-description">{{i.Value}}</dd>
      }
    </dl>
  </div>
}
